import { DocumentationLegacyPageBlockText, } from "./SDKDocumentationLegacyPageBlockText";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockCode extends DocumentationLegacyPageBlockText {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        var _a, _b;
        super(model, children);
        this.codeLanguage = (_a = model.codeLanguage) !== null && _a !== void 0 ? _a : null;
        this.caption = (_b = model.caption) !== null && _b !== void 0 ? _b : null;
    }
}
